import GELDesignTokens from '../GEL-design-tokens';
import { GELDesignTokensOverride } from "./override";

function override (origin, overrideObject) {
    for (const key of Object.keys(overrideObject)) {
        if (!origin.hasOwnProperty(key) || typeof overrideObject[key] !== 'object') {
            origin[key] = overrideObject[key];
        }
        else override(origin[key], overrideObject[key]);
    }
    return origin;
}

export const OverriddenGELDesignTokens = override(GELDesignTokens, GELDesignTokensOverride);
